export default {
  productAttribute: {
    AttributeName: 'Attribute Name',
    AttributeCode: 'Attribute Code',
    AttributeValueCode: 'Attribute Value Code',
    AttributeValueName: 'Attribute Value Name',
    AttributeDetails: 'Attribute Details',
    PleaseEnterAttributeName: 'Please Enter Attribute Name',
    PleaseEnterAttributeCode: 'Please Enter Attribute Code',
    PleaseAddProductAttribute: 'Please Add Product Attribute'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/pmc/productAttribute.js